(function ($) {
    document.addEventListener('DOMContentLoaded', () => {
        let formObserver;
        let tabsObserver;

        function rebuildForm(entries, observer) {
            entries.forEach(entry => {
                lazySizes.rAF(() => jcf.customForms.replaceAll(entry.target))
                formObserver.unobserve(entry.target);
            });
        }

        function initTabSet(entries, observer) {
            entries.forEach(entry => {
                lazySizes.rAF(() => $(entry.target).contentTabs({
                    tabLinks: 'a'
                }))
                tabsObserver.unobserve(entry.target);
            });
        }

        function initProductOptions() {
            document.removeEventListener('scroll', initProductOptions);
            document.removeEventListener('mousemove', initProductOptions);
            let d = document;
            script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.onload = () => {
                let el = document.querySelector('div[id^=shappify_custom_options]');
                if ('MutationObserver' in window && el) {
                    const observer = new MutationObserver(function (entry) {
                        lazySizes.rAF(() => jcf.customForms.replaceAll(entry.target))
                    });
                    observer.observe(el, {attributes: true, childList: true, subtree: true});
                }
            };
            script.src = '//secure.apps.shappify.com/apps/options/generate_options.php?shop=' + shappifyProductOptions.domain + '&product_id=' + shappifyProductOptions.product_id + '&_tmp=1619863965s';
            d.getElementsByTagName('head')[0].appendChild(script);
        }

        if ('IntersectionObserver' in window) {
            let forms = document.querySelectorAll('form');
            formObserver = new IntersectionObserver(rebuildForm, {threshold: 0.25});

            if (forms) {
                forms.forEach(form => formObserver.observe(form))
            }

            let tabs = document.querySelectorAll('ul.tabset');
            tabsObserver = new IntersectionObserver(initTabSet, {threshold: 0.25});

            if (tabs) {
                tabs.forEach(tab => tabsObserver.observe(tab))
            }
        } else {
            jcf.customForms.replaceAll();
            initTabs();
        }

        let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (isMobile) {
            initProductOptions();
        } else {
            document.addEventListener('scroll', initProductOptions, {passive: true});
            document.addEventListener('mousemove', initProductOptions, {passive: true});
        }
        $('#clear_bold_option_child').click(function() {
            let form = $('.product-form');
            form.find('.bold_option_child').prop('checked', false);
            form.find('select').prop('selectedIndex', 0);
            form.find('.select-bold_option_child .center').text('');
            form.find('.bold_option_child').trigger('change');
        });
    });
})(jQuery);
